import React, { Component } from 'react';
import { DatePicker, Form, Modal } from 'antd';
import moment from 'moment';
import UploadFile from '@comm/upload/UploadFile';

const { MonthPicker } = DatePicker;
const FormItem = Form.Item;
class FormImportWage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleOk = () => {
    const {
      handleSubmit,
      form: { validateFields },
    } = this.props;
    validateFields((err, values) => {
      if (!err) {
        const params = {
          year: moment(values.date).format('YYYY'),
          month: moment(values.date).format('MM'),
          fileUuid: values.files[0].uuid,
        };
        handleSubmit(params);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { wageLoading } = this.props;
    return (
      <Modal
        title="工资导入"
        onOk={this.handleOk}
        onCancel={this.props.handleCancel}
        confirmLoading={wageLoading}
        visible
      >
        <Form>
          <FormItem label="发放年月">
            {getFieldDecorator('date', {
              rules: [{ required: true, message: '请选择发放年月' }],
            })(<MonthPicker style={{ width: '100%' }} />)}
          </FormItem>
          <FormItem label="工资附件">
            {getFieldDecorator('files', {
              rules: [{ required: true, message: '请上传工资附件' }],
            })(<UploadFile limit={1} type="ghost" isPreview />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}
export default Form.create({ wrappedComponentRef: true })(FormImportWage);



// WEBPACK FOOTER //
// ./src/components/hr/wageImport/ModalImportWage.js